module.exports = __webpack_public_path__ + "static/img/hangyefenxi3.3956d962.png";